
import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Courses from '../components/Courses/Courses';
import Events from '../components/Event/Event';
import CeoMessage from '../components/CeoMessage/CeoMessage';
import Contact from '../components/Contact/Contact';
import useAPI from '../hooks/useAPI';
import TeamOnly from '../components/About/AboutPreview';
import Loading from '../components/Loading/Loading';


const Home = () => {
  const {
    data: homeData,
    loading,
    error,
  } = useAPI('/home');

  if (loading) {
    return <Loading/>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <Hero  data={homeData?.data?.hero} />
      <About />
      <Services data={homeData?.data?.services} />
      <Courses data={homeData?.data?.courses} />
      <CeoMessage data={homeData?.data?.leadership} />
      <TeamOnly/>
      <Events />
      <Contact data={homeData?.data?.settings} />
    </>
  );
};

export default Home;